module.exports = __webpack_public_path__ + "img/Trophy Cup Table36.2146e6ec.jpg";